
import {
    uuid
} from 'vue-uuid';
//获取埋点平台地址
function getDatacenterrestAddr() {
    let str = 'https://datacenterrest-dev.jiaoyanyun.com'
    if (process.env.NODE_ENV === 'development') {
        str = 'https://datacenterrest-dev.jiaoyanyun.com'
    } else if (process.env.NODE_ENV === 'dev') {
        str = 'https://datacenterrest-dev.jiaoyanyun.com'
    }
    else if (process.env.NODE_ENV === 'fz') {
        str = 'https://datacenterrest-fz.jiaoyanyun.com'
    } else {
        str = 'https://datacenterrest.speiyou.com'
    }
    return str;
}

/*
from:埋点编码
eventType:事件具体类型，点击 click  焦点 focus  曝光 loading
params：自定义参数*/
const uploadBussinessLog = function (from, eventType, params) {
    let obj;
    if (typeof params === 'object') {
        obj = params;
    } else {
        obj = {
            params
        }
    }
    uploadBussiness(from, eventType, obj);
}

function uploadBussiness(from, eventType, params) {
    // console.log("uploadBussinessLog")
    let img = document.createElement('img')
    img.src = `${getDatacenterrestAddr()}/data/report?data=${JSON.stringify({
        eventId: uuid.v1(),
        time: Date.now(),
        systemCode: "tishuashua",
        userId: localStorage.getItem("userId") || localStorage.getItem("visitorId"),
        sceneCode: "tishuashua",
        organizationCode: "neirongyun",
        from: from,
        eventTypeCode: eventType,
        params: params,
    })}`
    img.setAttribute('visibility', 'hidden')
    document.body.appendChild(img)
    document.body.removeChild(img)
}

export {
    uploadBussinessLog
}



// WEBPACK FOOTER //
// ./src/js/utils/bussinessLog.js